import { Square2StackIcon } from '@heroicons/react/24/outline';
import { Switch } from '@main/complykit';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { DrawerProperty } from '@main/ui';

import { useUpdateOrganizationHandler } from './use-update-org-handler';

export const ControlsModuleSwitch = ({ orgId }: { orgId: string }) => {
  const { data } = useGetOrganizationQuery({ orgId });
  const organization = data?.organizations_by_pk;
  const [updateOrganization, { isLoading }] = useUpdateOrganizationMutation();
  const updateOrgHanlder = useUpdateOrganizationHandler(orgId);

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label
        id="controls-module-label"
        htmlFor="controls-module"
        icon={Square2StackIcon}
      >
        Controls module
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} display="flex" alignItems="center">
        <Switch
          id="controls-module"
          aria-labelledby="controls-module-label"
          isSelected={organization.is_controls_module_enabled}
          isPending={isLoading}
          onChange={async () => {
            updateOrgHanlder(
              updateOrganization({
                organization_id: orgId,
                updatePayload: {
                  is_controls_module_enabled: !organization.is_controls_module_enabled,
                  ...(organization.is_controls_module_enabled && {
                    is_control_ai_review_enabled: false,
                    is_client_questionnaires_enabled: false,
                    is_program_creation_enabled: false,
                  }),
                },
              }),
            );
          }}
        />
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
